<script>
import ContractRestructuringViewMenu from '../../components/js/Components/ContractRestructuring/View/ContractRestructuringViewMenu.vue'
import PageLayout from '../../components/js/Components/UI/PageLayout.vue'
import mixinComponent from '../../components/js/Mixins/mixinComponent.js'
import { globalMethodsMixin, globalVariablesMixin } from '../../components/js/Mixins/global.js'
import MainContainer from '../../components/js/Components/UI/Content/MainContainer.vue'
import MainContent from '../../components/js/Components/UI/Content/MainContent.vue'
import ContractRestructuringMenu from '../../components/js/Components/ContractRestructuring/ContractRestructuringMenu.vue'
import { Routes } from '../../Constants/Routes.ts'
import { JSONError } from '../../Errors/JsonError.js'

export default {
  components: {
    ContractRestructuringViewMenu,
    ContractRestructuringMenu,
    MainContainer,
    MainContent,
    PageLayout,
  },
  mixins: [mixinComponent, globalVariablesMixin, globalMethodsMixin],
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    restructuring: null,
    editMode: false,
    activeMenu: 'information',
    form: {
      data: {},
    },
    loading: true,
    sending: false,
    canceling: false,
  }),
  computed: {
    pending() {
      return this.restructuring?.status === 'PENDING'
    },
  },
  methods: {
    async fetchRestructuring() {
      try {
        this.loading = true
        this.restructuring = await this.getJSON(`contracts/restructuring/${this.id}`, {
          displayError: false,
          noWaitingModal: true,
        })
        this.loading = false
      } catch (error) {
        let message = this.$t('security.error.bad_request')
        if (error instanceof JSONError && error.statusCode === 404) {
          message = this.$t('restructuring.error.not_found', { id: this.id })
        }

        this.toast(message)

        this.$router.push({ name: Routes.RESTRUCTURING_LIST })
      }
    },
    handleUpdate({ restructuring }) {
      this.restructuring = restructuring
    },
  },
  watch: {
    '$route.params.id': {
      handler() {
        this.fetchRestructuring()
      },
      immediate: true,
    },
  },
}
</script>
<template>
  <PageLayout menu="restructuring">
    <MainContainer>
      <MainContent>
        <ContractRestructuringViewMenu :restructuring="restructuring" />

        <router-view v-slot="{ Component }">
          <keep-alive :exclude="['ContractRestructuringDocumentsTab']">
            <component
              :is="Component"
              :restructuring="restructuring"
              @update="handleUpdate"
              @cancel="fetchRestructuring"
            />
          </keep-alive>
        </router-view>
      </MainContent>
    </MainContainer>
  </PageLayout>
</template>
